import "./HeaderMenu.scss";
import React, { useEffect, useState } from "react";
import HeaderMenuItem from "./HeaderMenuItem";

const HeaderMenu = ({ menuData }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    // Nasłuchujemy zmian szerokości ekranu
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };

        window.addEventListener("resize", handleResize);

        // Cleanup listener
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    // Sprawdzenie, czy `menuData` istnieje i zawiera dane
    if (!menuData || !menuData.items || menuData.items.length === 0) {
        return null; // Jeśli brak danych, nie renderuj nic
    }

    return (
        <nav id="main-nav" className="main-menu">
            <ul className="menu depth-0">
                {menuData.items.map((item) => (
                    <HeaderMenuItem key={item.id} item={item} depth={0} isMobile={isMobile} />
                ))}
            </ul>
        </nav>
    );
};

export default HeaderMenu;
